// extracted by mini-css-extract-plugin
module.exports = {"featuredCollectionCategory":"styles_featuredCollectionCategory__p7Eyp","featuredCollectionCategoryContainer":"styles_featuredCollectionCategoryContainer__K_hBr"};